import { normalizeCompanyConfigurationsContainer } from '../utils/companyConfigurations';

const initialState = {
  user: null,
  data: [],
  loading: true,
  error: null,
  userInfoLastFetchedAt: null
};

const removeNilFields = obj =>
  Object.fromEntries(
    Object.entries(obj || {}).filter(
      ([, value]) => value !== null && value !== undefined
    )
  );

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'WATCH_AUTH_STATE':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'SET_SIGN_IN_LOADING':
      return {
        ...state,
        loading: action.payload
      };
    case 'SIGN_OUT_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };

    case 'SIGN_OUT_SUCCESS':
      return {
        loading: false,
        error: null,
        userInfoLastFetchedAt: null
      };

    case 'SIGN_OUT_FAILURE':
      return {
        ...state,
        error: action.payload
      };
    case 'SIGN_IN_SUCCESS':
      // Keep previously known user fields (e.g. leadType) if the new payload is partial.
      return {
        ...state,
        loading: false,
        user: {
          ...(state.user || {}),
          ...removeNilFields(action.payload || {})
        }
      };
    case 'SIGN_IN_FAILURE':
      return {
        ...state,
        error: action.payload
      };

    case 'FETCH_DATA_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'FETCH_DATA_SUCCESS': {
      const payload = normalizeCompanyConfigurationsContainer(action.payload);
      const isDirectUserPayload =
        payload &&
        typeof payload === 'object' &&
        !Array.isArray(payload) &&
        !payload.user &&
        !payload.data &&
        !!payload.uid;
      const fetchedUser = removeNilFields(
        payload?.user ||
          payload?.data?.user ||
          (isDirectUserPayload ? payload : {})
      );
      return {
        ...state,
        userInfo: payload,
        userInfoLastFetchedAt: new Date().toISOString(),
        user:
          Object.keys(fetchedUser).length > 0
            ? {
                ...(state.user || {}),
                ...fetchedUser
              }
            : state.user,
        loading: false,
        error: null
      };
    }
    case 'FETCH_DATA_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default rootReducer;
